export const API_URL = 'https://apiv1.erp.campestreags.com/api/';
export const DOCUMENTS_URL = 'https://apiv2.erp.campestreags.com/';
export const NEW_API_URL = 'https://apiv2.erp.campestreags.com/api/';
export const CAMPESTRE_API = 'https://campestreags.com/wp-json/';
export const MQTT_HOST = "wss://campestreags.com/wss-mqtt"
export const MQTT_USERNAME = "TekoMQ"
export const MQTT_PASSWORD = "TekoMQ22.*"
